import { CmsObjectWithDefault } from '@components/Cms/types';

export type DatePickerCmsWithDefaultKey = 'ListOfMonth';

export const DatePickerCmsWithDefault: CmsObjectWithDefault<DatePickerCmsWithDefaultKey> = {
    ListOfMonth: {
        cmsId: 70236,
        defaultTranslation: 'January,February,March,April,May,June,July,August,September,October,November,December',
    },
};
